import { render, staticRenderFns } from "./AppAflossenHypotheekdeel.vue?vue&type=template&id=ededdf60&scoped=true&"
import script from "./AppAflossenHypotheekdeel.ts?vue&type=script&lang=ts&"
export * from "./AppAflossenHypotheekdeel.ts?vue&type=script&lang=ts&"
import style0 from "./AppAflossenHypotheekdeel.scss?vue&type=style&index=0&id=ededdf60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ededdf60",
  null
  
)

export default component.exports